import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.regexp.split.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions, mapMutations } from 'vuex';
import pickBy from 'lodash/pickBy';
import isNil from 'lodash/isNil';
import defer from 'lodash/defer';
import shallowEqualObjects from 'shallow-equal/objects';
import registerStoreModule from '~/helpers/store-helper';
import pageActions from '~/store/modules/pageActions';
import category from '~/store/modules/category';
import { extractCategoryHash, extractCategoryFilterByFromQuery, extractCategorySortByFromQuery, extractCategoryOrderByFromQuery, extractCategoryPreviousPageFromQuery, extractCategoryNextPageFromQuery, extractCategoryQueryFromFilterBy, extractSelectedFilters } from '~/helpers/extract-helper';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
import CategorySeo from '~/components/functional/Seo/CategorySeo.vue';
import RatingJsonLd from '~/components/functional/RatingJsonLd.vue';
import CategoryTcVars from '~/components/functional/TcVars/CategoryTcVars.vue';
import CategoryJsonld from '~/components/functional/JsonLD/CategoryJsonld.vue';
import CategoryCatalog from '~/components/organisms/Category/CategoryCatalog.vue';
import CategoryInformationalContent from '~/components/organisms/Category/CategoryInformationalContent.vue';
import CategoryLoading from '~/components/templates/Category/CategoryLoading.vue';
import CategoryTemplate from '~/components/templates/Category/CategoryTemplate.vue';
import Empty from '~/components/specific/Blocks/Empty.vue';
import CommercialRibbon from '~/components/atoms/Global/CommercialRibbon.vue';
import activateOpenFacets from '~/const/openFacet';
export default {
  validate(_ref) {
    var {
      params: {
        alias
      }
    } = _ref;
    return alias && extractCategoryHash(alias);
  },

  components: {
    MdmBreadcrumb,
    CategorySeo,
    CategoryTcVars,
    CategoryJsonld,
    CategoryCatalog,
    CategoryInformationalContent,
    CategoryLoading,
    CategoryTemplate,
    Empty,
    CommercialRibbon,
    RatingJsonLd
  },
  httpHeaders: (_ref2) => {
    var {
      app
    } = _ref2;
    return _objectSpread({
      'Cache-Control': 'max-age=0, s-maxage=86400, public'
    }, activateOpenFacets(app.store.$cookies) && app.store.state.searchEngine.isSearchEngine && {
      'mdm-client-type': 'bot',
      Vary: 'mdm-client-type'
    });
  },

  fetch(_ref3) {
    return _asyncToGenerator(function* () {
      var {
        params: {
          alias
        },
        query,
        store,
        error
      } = _ref3;
      registerStoreModule(store, 'category/', category);
      registerStoreModule(store, 'pageActions/', pageActions);

      if (process.server) {
        store.commit('pageActions/SET_DEFAULT_FILTERBY', extractCategoryFilterByFromQuery(query));
        store.commit('pageActions/SET_DEFAULT_SORTBY', extractCategorySortByFromQuery(query));
        store.commit('pageActions/SET_DEFAULT_ORDERBY', extractCategoryOrderByFromQuery(query));
        store.commit('pageActions/SET_PREVIOUS_PAGE', extractCategoryPreviousPageFromQuery(query));
        store.commit('pageActions/SET_NEXT_PAGE', extractCategoryNextPageFromQuery(query));

        try {
          yield store.dispatch('category/fetchContent', {
            alias,
            query
          });
        } catch (err) {
          error({
            statusCode: 404,
            message: 'Not Found'
          });
        }
      }
    })();
  },

  asyncData() {
    return {
      serverFetch: process.server
    };
  },

  data() {
    return {
      loadingProducts: true,
      loadingNextPage: false,
      loadingPreviousPage: false,
      unwatchCategoryQuery: null,
      unwatchNextPage: null,
      unwatchPreviousPage: null
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    baseURL: 'request/baseURL',
    locale: 'i18n/locale',
    description: 'category/description',
    products: 'category/products',
    productsCount: 'category/productsCount',
    filterBy: 'pageActions/filterBy',
    orderBy: 'pageActions/orderBy',
    sortBy: 'pageActions/sortBy',
    previousPage: 'pageActions/previousPage',
    nextPage: 'pageActions/nextPage'
  })), {}, {
    categoryQuery() {
      return _objectSpread(_objectSpread({}, extractCategoryQueryFromFilterBy(this.filterBy)), {}, {
        sort: this.sortBy,
        order: this.orderBy
      });
    },

    selectedFilters() {
      return extractSelectedFilters(this.filterBy, this.description.filters);
    },

    currentPath() {
      return "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, this.description.slug, this.description.hash));
    },

    breadcrumb() {
      var breadcrumb = this.description.breadcrumb || [];
      return breadcrumb.map(entry => ({
        label: entry.title,
        url: entry.slug ? "".concat(this.baseURL).concat(this.buildCategoryUrl(this.locale, entry.slug, entry.hash)) : "/".concat(this.locale.market, "/").concat(this.locale.language)
      }));
    },

    pageTitle() {
      return this.description.seo.meta_title || this.description.name || '';
    },

    speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX = window.LUX || {}; LUX.label = "category";'
      };
      return luxConfig;
    },

    title() {
      return this.description.title || '';
    },

    categoryImage() {
      return this.products && this.products[0] && this.products[0].images && this.products[0].images[0] ? this.products[0].images[0].src : null;
    },

    isSearchQueryAlgolia() {
      return this.$route.query.query;
    },

    hasOpenFacets() {
      if (this.$store.state.searchEngine.isSearchEngine && activateOpenFacets(this.$cookies)) {
        return !this.description.filters.every(filter => {
          var {
            facets
          } = filter;
          var isSeoFacets = !facets.min || !facets.max;
          var hasSelectedOpenFacet = [];
          if (isSeoFacets) hasSelectedOpenFacet = facets.filter(facet => facet.selected && facet.is_open);
          return hasSelectedOpenFacet.length <= 0;
        });
      }

      return false;
    }

  }),

  created() {
    registerStoreModule(this.$store, 'category/', category, true);
    registerStoreModule(this.$store, 'pageActions/', pageActions, true);

    if (process.client && !this.serverFetch) {
      var {
        params: {
          alias
        },
        query
      } = this.$route;
      var args = {
        alias,
        query,
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.resetPagination();
      this.resetFilters();
      this.resetCategory();
      this.setDefaultFilterBy(extractCategoryFilterByFromQuery(query));
      this.setDefaultSortBy(extractCategorySortByFromQuery(query));
      this.setDefaultOrderBy(extractCategoryOrderByFromQuery(query));
      this.setPreviousPage(extractCategoryPreviousPageFromQuery(query));
      this.setNextPage(extractCategoryNextPageFromQuery(query));

      try {
        this.fetchCategory(args).then(() => {
          this.loadingProducts = false;
          this.createEbRecord();
          this.scrollBackToProduct(localStorage.getItem('currentProduct'));
          localStorage.removeItem('currentProduct');
        });
      } catch (error) {
        this.$logger.error(error);
      }
    }
  },

  mounted() {
    var _this = this;

    if (this.serverFetch) {
      this.fetchProducts();
    }

    this.unwatchCategoryQuery = this.$watch('categoryQuery', /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* (oldVal, newVal) {
        if (!shallowEqualObjects(oldVal, newVal)) {
          _this.loadingProducts = true;
          yield _this.handleWatcher(_this.fetchCategory, 1);

          _this.resetPagination();

          _this.loadingProducts = false;
        }
      });

      return function (_x, _x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    this.unwatchNextPage = this.$watch('nextPage', /*#__PURE__*/_asyncToGenerator(function* () {
      var predicate = _this.nextPage === 1 && _this.previousPage === 1;

      if (!predicate) {
        _this.loadingNextPage = true;
        yield _this.handleWatcher(_this.appendProducts, _this.nextPage);
        _this.loadingNextPage = false;
      }
    }));
    this.unwatchPreviousPage = this.$watch('previousPage', /*#__PURE__*/_asyncToGenerator(function* () {
      var predicate = _this.nextPage === 1 && _this.previousPage === 1;

      if (!predicate) {
        _this.loadingPreviousPage = true;
        yield _this.handleWatcher(_this.prependProducts, _this.previousPage);
        _this.loadingPreviousPage = false;
      }
    }));
  },

  beforeDestroy() {
    this.unwatchCategoryQuery();
    this.unwatchNextPage();
    this.unwatchPreviousPage();
  },

  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    setDefaultFilterBy: 'pageActions/SET_DEFAULT_FILTERBY',
    setDefaultSortBy: 'pageActions/SET_DEFAULT_SORTBY',
    setDefaultOrderBy: 'pageActions/SET_DEFAULT_ORDERBY',
    setPreviousPage: 'pageActions/SET_PREVIOUS_PAGE',
    setNextPage: 'pageActions/SET_NEXT_PAGE',
    resetPagination: 'pageActions/RESET_PAGINATION',
    resetFilters: 'pageActions/RESET_FILTERS',
    resetCategory: 'category/RESET_CATEGORY'
  })), mapActions({
    fetchCategory: 'category/fetchContent',
    appendProducts: 'category/appendProducts',
    prependProducts: 'category/prependProducts'
  })), {}, {
    createEbRecord() {
      if (this.description) {
        var earlybirdsId = this.description.earlybirdsWidgets ? this.description.earlybirdsWidgets.id : null;
        window.ebRecoIds = [earlybirdsId];
      }
    },

    fetchProducts() {
      var args = {
        alias: this.$route.params.alias,
        query: _objectSpread(_objectSpread({}, this.categoryQuery), {}, {
          page: this.nextPage
        }),
        profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
      };
      this.fetchCategory(args).then(() => {
        this.loadingProducts = false;
        this.createEbRecord();
        this.$root.$emit('reset-tcvars');
      });
    },

    handleWatcher(handler, page) {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        var {
          params: {
            alias
          }
        } = _this2.$route;

        var query = _objectSpread(_objectSpread({}, _this2.categoryQuery), {}, {
          page
        });

        _this2.$root.$emit('sticky-filters-data', _this2.selectedFilters);

        var profileId = _this2.$cookies.get('eb-profile') ? _this2.$cookies.get('eb-profile').split(':')[0] : '';

        try {
          yield handler({
            alias,
            query,
            profileId
          });

          _this2.$router.push({
            query: pickBy(query, e => !isNil(e))
          });

          if (!_this2.isSearchQueryAlgolia) {
            _this2.$root.$emit('reset-tcvars');
          }
        } catch (err) {
          _this2.$logger.error(err);
        }
      })();
    },

    scrollBackToProduct(arg) {
      if (arg) {
        var currentProduct = JSON.parse(arg);
        defer(() => {
          var product = document.getElementById(currentProduct);

          if (product) {
            window.scrollTo({
              top: product.offsetTop
            });
          }
        });
      }
    }

  }),

  head() {
    return {
      script: [this.speedcurveConfig]
    };
  }

};